"use client"

import Link from "next/link"
import TravelExploreRoundedIcon from "@mui/icons-material/TravelExploreRounded"
import { Box, Typography } from "@mui/material"
import type { TitleProps } from "@refinedev/core"

export function AppTitle({ collapsed }: TitleProps) {
  return (
    <Box
      component={Link}
      href="/dashboard"
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        textDecoration: "none",
        minHeight: 44,
      }}
    >
      <TravelExploreRoundedIcon color="primary" sx={{ fontSize: 22 }} />
      {!collapsed && (
        <Box sx={{ minWidth: 0 }}>
          <Typography
            variant="h6"
            sx={{
              lineHeight: 1.1,
              color: "text.primary",
              whiteSpace: "nowrap",
            }}
          >
            Along
          </Typography>
          <Typography
            sx={{
              display: "none", // 培训展示期间暂时隐藏英文副标，保留恢复入口。
              mt: 0.25,
              fontSize: 10,
              letterSpacing: 1.4,
              textTransform: "uppercase",
              color: "text.secondary",
              whiteSpace: "nowrap",
            }}
          >
            Pure One Operations
          </Typography>
        </Box>
      )}
    </Box>
  )
}
